import { render, staticRenderFns } from "./TabModeratorFestivalFestivalSchool.vue?vue&type=template&id=50fc59ea&"
import script from "./TabModeratorFestivalFestivalSchool.vue?vue&type=script&lang=js&"
export * from "./TabModeratorFestivalFestivalSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
